import { formatPhoneNumberInternational, formatPhoneNumberUrl } from 'helpers/phoneNumber';
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const PhoneRenderer = (props) => {
  const number = props.value

  return (
    <Link to={formatPhoneNumberUrl(number)}>{formatPhoneNumberInternational(number) || number}</Link>
  );
};

PhoneRenderer.propTypes = {
  value: PropTypes.string
};

export default PhoneRenderer;
